import XhrRequestHandler from '../../lib/XhrRequestHandler';

export interface IUserProfile {
  per_id: string;
  per_nombre: string;
  per_nemotecnico: Nemotecnico;
  per_activo: boolean;
}

export enum Nemotecnico {
  stdUser = "stdUser",
  pwrUser = "pwrUser",
  adminUser = "adminUser",
  executive = "executive",
  talHum = "talHum",
}

export class UserProfileSystem {
  private readonly base = '/perfiles-usuarios';

  constructor(private requestHandler: XhrRequestHandler) {}

  async getUserProfiles() {
    return await this.requestHandler.getheader<IUserProfile[]>(`${this.base}/obtener-perfiles`, {
      uuid: 'perfiles',
      message: 'Obtener perfiles para el usuario',
    });
  }
}
